import { render, staticRenderFns } from "./MuaLaiSim.vue?vue&type=template&id=46fde80b&scoped=true"
import script from "./MuaLaiSim.vue?vue&type=script&lang=js"
export * from "./MuaLaiSim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fde80b",
  null
  
)

export default component.exports